module.exports = __webpack_public_path__ + "static/media/300x600.a820eae8.jpg";